/* eslint-disable */
export default {
  removeMeetingWarning:
    'La función de programación está interrumpida. Utilice{app}para programar sus reuniones por vídeo.',
  scheduleMeetingTips:
    'Tenga en cuenta que hemos eliminado las reuniones de esta aplicación. Si desea usar esa función, le recomendamos{app}.',
  migrateToPluginAlert:
    'Nota: Esta aplicación no funcionará con la versión de Outlook 2016 y anteriores ni en Internet Explorer 11. Actualice su Outlook o cambie a Microsoft Edge, o como alternativa, cambie a{app}',
} as const;

// @key: @#@"removeMeetingWarning"@#@ @source: @#@"The scheduling feature is discontinued. Please use the {app} to schedule your video meetings."@#@
// @key: @#@"scheduleMeetingTips"@#@ @source: @#@"Please note that we removed meetings from this app. To use meetings, we recommend the {app}."@#@
// @key: @#@"migrateToPluginAlert"@#@ @source: @#@"Note: This app will not work with Outlook version 2016 and below and Internet Explorer 11. Please upgrade your Outlook or switch to Microsoft Edge, or alternately, switch to {app}"@#@
